/**
 * Single source of truth for product categories across AddProductForm and ProductDetail.
 * Use "Other" when the product doesn't fit; UI can allow free-text in that case.
 */
export const PRODUCT_CATEGORIES = [
  'Cleanser',
  'Toner',
  'Serum',
  'Moisturizer',
  'Sunscreen',
  'Eye Care',
  'Exfoliant',
  'Mask',
  'Oil',
  'Spot Treatment',
  'Makeup',
  'Hair Care',
  'Body Care',
  'Fragrance',
  'Tools & Accessories',
  'Other'
];
